import metricRanges, { type MetricScales } from '@/scripts/definitions/metrics-scales'

/**
 * Gets metric feedback label by level
 * @name Metric Feedback label
 * @param {string | number} value - privacy gown
 * @param {string} metric - security
 * @returns {string} feedback label
 */

export const metricFeedback = (value: number | 'none', metric: keyof MetricScales): string => {
  // Null/undefined values
  if (!value && value !== 0) {
    return 'none'
  }
  const levelIndex = value === 'none' ? 0 : value - 1

  return metricRanges[metric][levelIndex].label
}

/**
 * Validate metric value by returning value or default placeholder when 'null' || 'undefined'
 * A module for adding two values.
 * @name Metric Scale
 * @param {value} value - privacy gown
 * @param {string} metric - security
 * @param {(x: number) => number} roundFunction - security
 * @returns {number | "none"}
 */

export const metricScale = (
  value: number,
  metric: keyof MetricScales,
  roundFunction: (x: number) => number = Math.round,
): number | 'none' => {
  // Null/undefined values
  if (!value && value !== 0) {
    return 'none'
  }
  const ranges = metricRanges[metric].map((l: { min: number | string }) => Number(l.min))

  if (!ranges) {
    return value === 0 ? 0 : Math.round(Math.floor(value) / 10)
  }

  return ranges.indexOf(ranges.reduce((prev, curr) => {
    return roundFunction(value) >= curr ? curr : prev
  })) + 1
}

/**
 * Ensures invalid metric values is correctly formatted across platform.
 * Returns metric value or default placeholder when 'null' || 'undefined'
 * @name Metric Value Validator
 * @param {number} value
 * @returns {(number|"-")}
 */
export const metricValidator = (value?: number): (number | '-') => {
  return !value && value !== 0 ? '-' : value
}
